import React, { useContext } from 'react';
import styled from '@emotion/styled';
import type { WPublicWeddingView, WCmsHomepageView } from '@zola/svc-web-api-ts-client';
import { ThemeContext } from '../../context';
import NamesModule from './WeddingInfoSection/NamesModule';
import WeddingInfoSection from './WeddingInfoSection';
import StorySection from './StorySection';
import FooterImage from './FooterImage';

type HomeProps = {
  wedding?: WPublicWeddingView;
  homepageData?: WCmsHomepageView;
};

const Home = ({ wedding, homepageData }: HomeProps): JSX.Element => {
  const { footer_image_url, homepage_sections: entities } = homepageData || {};

  const {
    components: { Button },
  } = useContext(ThemeContext);

  const RSVPButton = styled(Button)`
    margin-top: 84px;
    width: 300px;
  `;

  const RSVPButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const { owner_first_name, owner_last_name, partner_first_name, partner_last_name } =
    wedding || {};

  return (
    <>
      <NamesModule
        ownerFirstName={owner_first_name}
        ownerLastName={owner_last_name}
        partnerFirstName={partner_first_name}
        partnerLastName={partner_last_name}
      />
      <WeddingInfoSection wedding={wedding} />
      <RSVPButtonContainer>
        <RSVPButton>RSVP</RSVPButton>
      </RSVPButtonContainer>
      <StorySection homepageSections={entities} />
      <FooterImage imageUrl={footer_image_url} />
    </>
  );
};

export default Home;
